module.exports = __webpack_public_path__ + "static/media/icons_Bilan Coude.ef3056b7.svg";